import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "crm:flex" }
const _hoisted_2 = {
  key: 0,
  class: "crm:mb-4!"
}
const _hoisted_3 = { class: "crm:py-2 crm:my-2 crm:inline-block crm:w-full" }
const _hoisted_4 = { class: "crm:pl-4 text-black" }
const _hoisted_5 = { class: "crm:p-2 crm:flex flex-column crm:bg-white crm:cursor-pointer" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "crm:justify-end crm:flex crm:mt-4" }
const _hoisted_8 = { class: "crm:flex crm:items-center crm:justify-between crm:mt-4" }
const _hoisted_9 = {
  key: 1,
  class: ""
}
const _hoisted_10 = { class: "crm:flex crm:justify-end" }

import {reactive, computed, inject, onMounted, provide} from "vue";
import {useChecklistStore, usePraticaStore} from "../../store/crm.store";
import Questionario from "../../composable/Questionario.class";
import AppChecklistMatriceRichiesta from "./AppChecklistMatriceRichiesta.vue";
import {useChecklist} from "../../composable/useChecklist";
import {alert_add, alert_information_circle} from "../../svg/svgs.js"
import {httpPost} from "../../api/http_caller";
import {useDefineModal} from "../../composable/definer/useDefineModal";


export default {
  __name: 'AppChecklistMatrice',
  props: {
  /**
   * ID della checklist, utilizzato nel caso di aggiunta richieste documenti lato notaio
   * ad una checklist già esistente
   */
  checklistId: {
    type: [String, Number],
    default: null
  },
  /**
   * ID del soggetto di riferimento
   */
  soggettoId: {
    type: [String, Number],
    default: null
  },
  /**
   * se impostato forza apertura di accordion della matrice di checklist
   */
  forceAccordionActived: {
    type: Object,
    default() {
      return {}
    }
  },
  /**
   * Se impostato auto check richieste di documenti passate
   */
  richiesteDocumentiDefault: {
    type: [Object, Array],
    default() {
      return {}
    }
  },
  /**
   * Se impostato inserisce una nota generale di checklist di default
   */
  notaChecklistDefault: {
    type: String,
    default: ''
  }
},
  emits: [
  /**
   * Emit per Callback dopo aver inviato e confermato una checklist
   */
  'save:checklist'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc
 * Gestisce la renderizzazione e le funzionalità associate all'aggiunta di richieste documenti ad una checklist
 * già esistente o in fase di creazione
 */
const checklistStore = useChecklistStore();
const praticaStore = usePraticaStore();

/**
 * @inject {$DesignSystem} recupera la lista dei colori/configurazioni del design system
 */
const $DesignSystem = inject('$DesignSystem')

const props = __props

const emits = __emit

/**
 * @inject {$AxiosClient} recupera la libreria per le chiamate ajax
 */
const $AxiosClient = inject('$AxiosClient');

const use_checklist = useChecklist();

const checklistMatrice = reactive({
  // se popolato apre una o più accordion dall'elenco delle sezioni di una checklist - utilizzato durante il match di un modello
  accordionActived: props.forceAccordionActived ? props.forceAccordionActived : {},
  // elenco delle richieste di documenti aggiunte (utilizzato sia in fase di creazione checklist che importazione modello)
  richiesteDocumenti: props.richiesteDocumentiDefault ? props.richiesteDocumentiDefault : {},
  // salva la nota generale della checklist
  notaChecklist: {value: props.notaChecklistDefault},
  // se true la checklist si sta inviando
  isSendChecklist: false,
  // testo predefinito della mail da inviare in caso di invio checklist e aggiunta nuova richiesta di documento
  testo_mail: [],
  // dati di riepilogo inerenti alla mail di invio
  dati_mail: {
    mittente: '',
    oggetto: ''
  },
  // dati del soggetto da mostrare nella conferma invio mail
  soggetto: null,
  // se true mostra la conferma di invio checklist e conferma email
  isShowConferma: false
})

// controllo che almeno un accordion sia espanso (serve per gestire i bottoni di conferma fixed)
const isAccordionOpen = computed(() => Object.values(checklistMatrice.accordionActived).indexOf(true) > -1)

// aggiorno elenco degli accordion in base agli elementi del modello di base della checklist
const accordionRows = computed(() => {
  let rows = [];
  if (checklistStore.checkList['checklist'] !== undefined) Object.values(checklistStore.checkList.checklist).forEach((itemList) => rows.push({title: itemList.title, controls: itemList.title}))
  return rows;
})

const modaleConfermaInvioChecklist = useDefineModal('conferma_invio_checklist', 'Invia checklist', false)

/**
 * Aggiunge richiesta di documento alla checklist.
 * Ogni richiesta documento personalizzato possiede:
 * - custom: true -> indica che è una richiesta documento personalizzata
 * - keyMap formato da KEYMAP_SEZIONE|KEYMAP_CATEGORIA|KEY_MAP_RICHIESTA_DOCUMENTO_PERSONALIZZATO
 * KEY_MAP_RICHIESTA_DOCUMENTO_PERSONALIZZATO è un hash generato randomicamente per permettere di poter inserire più documenti personalizzati
 * per sezione|categoria.
 * Questa struttura di keyMap serve in fase di mapping tra modello checklist base e modello checklist salvato
 * @param category
 * @param sectionKeyMap
 * @param categoryKeyMap
 */
function aggiungiDocumentoPersonalizzato(category, sectionKeyMap, categoryKeyMap) {
  let customKeyMap = `${sectionKeyMap || ''}|${categoryKeyMap || ''}|${Questionario._generateHash()}`;
  let customElement = {
    label: '',
    title: '',
    keyMap: customKeyMap,
    custom: true
  };
  category.documents.push(customElement);
  checklistMatrice.richiesteDocumenti[customKeyMap] = customElement;
}

function enableConfirmButton() {
  const hasRichieste = checklistMatrice.richiesteDocumenti && Object.keys(checklistMatrice.richiesteDocumenti).length > 0;
  let isValid = hasRichieste;
  if (hasRichieste) {
    let richiestaWithNoLabel = (Object.entries(checklistMatrice.richiesteDocumenti)).filter(([key, richiesta]) => {
      return richiesta.label === ''
    });
    isValid         = richiestaWithNoLabel.length === 0;
  }

  return isValid;
}

/**
 * Invia checklist al cittadino
 * @returns {Promise<void>}
 */
async function inviaCheckList() {
  checklistMatrice.isSendChecklist = true;
  Object.keys(checklistMatrice.testo_mail).forEach((lingua) => checklistMatrice.testo_mail[lingua].testo = checklistMatrice.testo_mail[lingua].value)
  let sendQuestionario = await $AxiosClient.post(
    props.checklistId ? 'Questionario' : 'Questionari',
    props.checklistId ? 'addRichiesta' : 'sendQuestionario',
    {...{testo_mail: JSON.stringify(checklistMatrice.testo_mail)}, ...use_checklist.generateChecklistToSave(props.soggettoId, checklistMatrice.richiesteDocumenti, checklistMatrice.notaChecklist, props.checklistId, true)},
    {headers: {"Content-Type": "multipart/form-data"}, messages:'error'}
  )

  if (sendQuestionario && sendQuestionario.esito === 'ok') {
    checklistMatrice.isShowConferma = true;
  }

  if (sendQuestionario && sendQuestionario.esito === 'ko') checklistMatrice.isSendChecklist = false;
}

onMounted(async() => {
  checklistMatrice.isShowConferma = false;
  if(praticaStore.tipoUtenteConnesso === 'notaio' && (!props.richiesteDocumentiDefault || Object.keys(props.richiesteDocumentiDefault).length === 0)) await checklistStore.getChecklist()
  let getSoggettoData = await httpPost('Soggetto', 'getSoggettoData', {soggetto_id: props.soggettoId}, {messages: 'error', loading: false})
  if(getSoggettoData && getSoggettoData.esito === 'ok') checklistMatrice.soggetto = getSoggettoData.data;
})

/**
 * metodo che viene richiamato dai componenti ChecklistTemplateRichiesta e gestisce il toggle di inserimento/cancellazione richiesta documento
 * @param params
 * @param element
 */
function updateRichiesta(params, element) {
  if (params.active === '1') {
    checklistMatrice.richiesteDocumenti[element.keyMap] = {...element, ...{category_ref: params.category_ref, name: element.label, formato: params.formato.value, hash: params.hash, id: params.id}};
    // se è presente la label nei params vuol dire che si tratta di una richiesta di documento aggiunta e non presente nel modello iniziale
    if(params['label'] !== undefined && params['label']) {
      checklistMatrice.richiesteDocumenti[element.keyMap].label = params.label;
      checklistMatrice.richiesteDocumenti[element.keyMap].name = params.label;
      checklistMatrice.richiesteDocumenti[element.keyMap].title = params.label;
    }
  } else {
    if(checklistMatrice.richiesteDocumenti) delete checklistMatrice.richiesteDocumenti[element.keyMap];
  }
}

/**
 * @provides {updateRichiesta} mette a disposizione dei figli la possibilità di aggiornare l'elenco delle richieste di documenti della checklist
 */
provide('updateRichiesta', updateRichiesta)

/**
 * Apre la modale di composizione mail da inviare in caso di invio checklist e aggiunta nuova richiesta di documento
 * Recupera il testo mail di default
 * Recupera i dati del soggetto per mostrare alcune info su chi riceverà la mail
 * @return {Promise<void>}
 */
async function apriModaleComposizioneMail() {
  let getTestoMail = await $AxiosClient.post('Questionario', 'getTestoMail', {pratica_id: praticaStore.praticaID, soggetto_id: props.soggettoId}, {messages: 'error'})
  checklistMatrice.testo_mail = getTestoMail.testo_mail;
  checklistMatrice.dati_mail.mittente = getTestoMail.mittente
  checklistMatrice.dati_mail.oggetto = getTestoMail.oggetto_mail
  Object.keys(checklistMatrice.testo_mail).forEach((lingua) => checklistMatrice.testo_mail[lingua]['value'] = checklistMatrice.testo_mail[lingua].testo)

  modaleConfermaInvioChecklist.open()
}

/**
 * Chiude le modali solo dopo aver confermato la lettura della conferma invio checklist e mail
 * @return {Promise<void>}
 */
async function chiudiModaliChecklist() {
  await praticaStore.onReInitPratica();
  modaleConfermaInvioChecklist.close();

  emits('save:checklist', props.soggettoId, true, {
    init: false,
    objectToRequest: {
      pratica_id: praticaStore.praticaID,
      soggetto_id: props.soggettoId,
      questionario_id: props.checklistId
    }
  });

  checklistMatrice.isSendChecklist = false;
}

return (_ctx, _cache) => {
  const _component_base_textarea_floating_label = _resolveComponent("base-textarea-floating-label")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_accordion = _resolveComponent("base-accordion")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_input_text_floating_label = _resolveComponent("base-input-text-floating-label")
  const _component_base_alert_message = _resolveComponent("base-alert-message")
  const _component_base_modal = _resolveComponent("base-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" @slot permette di overridare il titolo della matrice "),
      _renderSlot(_ctx.$slots, "matrice-title", {
        richiesteDocumenti: checklistMatrice.richiesteDocumenti,
        notaChecklist: checklistMatrice.notaChecklist
      }, () => [
        _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "crm:my-2 crm:flex" }, [
          _createElementVNode("span", null, "Checklist documenti")
        ], -1 /* CACHED */))
      ])
    ]),
    (checklistMatrice.richiesteDocumenti && Object.keys(checklistMatrice.richiesteDocumenti).length > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "N. documenti richiesti: " + _toDisplayString(Object.keys(checklistMatrice.richiesteDocumenti).length), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" @slot permette di overiddare le Istruzioni operative a beneficio del cliente "),
    _renderSlot(_ctx.$slots, "matrice-nota-generale", {}, () => [
      _createVNode(_component_base_textarea_floating_label, {
        name: "nota_generale",
        label: "Istruzioni operative a beneficio del cliente",
        validateTo: checklistMatrice.notaChecklist,
        "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((checklistMatrice.notaChecklist) = $event))
      }, null, 8 /* PROPS */, ["validateTo"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["crm:h-[450px] crm:mt-5 crm:border", [isAccordionOpen.value || (accordionRows.value && accordionRows.value.length > 9) ? 'crm:overflow-y-scroll' : 'crm:overflow-y-hidden']])
    }, [
      (accordionRows.value && _unref(checklistStore).checkList)
        ? (_openBlock(), _createBlock(_component_base_accordion, {
            key: 0,
            class: "crm:w-full",
            "custom-classes": {rowsContainer: {base: 'crm:mt-0|override'}},
            minimal: true,
            rows: accordionRows.value,
            "active-row-default": checklistMatrice.accordionActived,
            "onUpdate:activeRowDefault": _cache[1] || (_cache[1] = $event => ((checklistMatrice.accordionActived) = $event)),
            "single-active": true
          }, _createSlots({ _: 2 /* DYNAMIC */ }, [
            _renderList(_unref(checklistStore).checkList.checklist, (listItem) => {
              return {
                name: listItem.title,
                fn: _withCtx(() => [
                  (listItem.categories)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(listItem.categories, (category, indexCat) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `category-${indexCat}`,
                          class: "bg-light-gray crm:px-2 crm:pb-4"
                        }, [
                          _createElementVNode("span", _hoisted_3, [
                            _createElementVNode("b", _hoisted_4, _toDisplayString(category.title), 1 /* TEXT */)
                          ]),
                          _createCommentVNode(" loop dei documenti "),
                          (category.documents)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(category.documents, (document, indexDoc) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `doc-${indexDoc}`,
                                  class: "crm:p-2 crm:pt-2 crm:flex crm:flex-col crm:lg:flex-row crm:lg:items-center crm:bg-white crm:lg:justify-between"
                                }, [
                                  _createVNode(AppChecklistMatriceRichiesta, {
                                    section: listItem.title,
                                    document: document,
                                    "default-data": checklistMatrice.richiesteDocumenti && checklistMatrice.richiesteDocumenti[document.keyMap]
                                  }, null, 8 /* PROPS */, ["section", "document", "default-data"])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" genero cta per aggiungere un documento personalizzato "),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("span", {
                              onClick: _withModifiers($event => (aggiungiDocumentoPersonalizzato(category, listItem.keyMap, category.keyMap)), ["prevent"])
                            }, [
                              _createVNode(_component_base_icon, {
                                icon: _unref(alert_add),
                                stroke: _unref($DesignSystem).design_colors.primary,
                                class: "crm:mr-2"
                              }, null, 8 /* PROPS */, ["icon", "stroke"]),
                              _cache[6] || (_cache[6] = _createElementVNode("u", { class: "text-primary" }, "Aggiungi Documento", -1 /* CACHED */))
                            ], 8 /* PROPS */, _hoisted_6)
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ])
              }
            })
          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["rows", "active-row-default"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_7, [
      _createCommentVNode(" @slot permette di overridare il bottone di conferma e invia checklist/aggiungi richieste di documenti "),
      _renderSlot(_ctx.$slots, "matrice-cta", {
        richiesteDocumenti: checklistMatrice.richiesteDocumenti,
        isSendChecklist: checklistMatrice.isSendChecklist,
        notaChecklist: checklistMatrice.notaChecklist
      }, () => [
        _createVNode(_component_base_button, {
          mode: "confirm",
          "onClick:cta": apriModaleComposizioneMail,
          state: !enableConfirmButton() || checklistMatrice.isSendChecklist ? 'disable' : 'active'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.checklistId ? 'Aggiungi richieste di documenti' : `Conferma e invia a ${checklistMatrice?.soggetto?.ragione_sociale ? checklistMatrice?.soggetto?.ragione_sociale : `${checklistMatrice?.soggetto?.nome} ${checklistMatrice?.soggetto?.cognome}`}`), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["state"])
      ])
    ]),
    _createCommentVNode(" @slot permette di aggiungere elementi alla matrice di checklist "),
    _renderSlot(_ctx.$slots, "matrice-body", {
      richiesteDocumenti: checklistMatrice.richiesteDocumenti,
      updateNotaChecklist: (notaValue) => checklistMatrice.notaChecklist = notaValue,
      notaChecklist: checklistMatrice.notaChecklist
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(modaleConfermaInvioChecklist).getShow())
        ? (_openBlock(), _createBlock(_component_base_modal, {
            key: 0,
            title: _unref(modaleConfermaInvioChecklist).getTitle(),
            id: _unref(modaleConfermaInvioChecklist).getId(),
            size: "md",
            "onModal:closed": _cache[4] || (_cache[4] = $event => (_unref(modaleConfermaInvioChecklist).close())),
            "is-closable": !checklistMatrice.isShowConferma
          }, {
            default: _withCtx(() => [
              (!checklistMatrice.isShowConferma)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_base_input_text_floating_label, {
                      label: "Mittente",
                      name: "mittente_mail",
                      state: "readonly",
                      "validate-to": {value:`${checklistMatrice.dati_mail.mittente}`}
                    }, null, 8 /* PROPS */, ["validate-to"]),
                    _createVNode(_component_base_input_text_floating_label, {
                      label: "Destinatario",
                      name: "destinatario_mail",
                      state: "readonly",
                      "validate-to": {value: `${checklistMatrice?.soggetto?.ragione_sociale ? checklistMatrice?.soggetto?.ragione_sociale : `${checklistMatrice?.soggetto?.nome} ${checklistMatrice?.soggetto?.cognome}`} <${checklistMatrice.soggetto.email}>`}
                    }, null, 8 /* PROPS */, ["validate-to"]),
                    _createVNode(_component_base_input_text_floating_label, {
                      label: "Oggetto mail",
                      name: "oggetto_mail",
                      state: "readonly",
                      "validate-to": {value:`${checklistMatrice.dati_mail.oggetto}`}
                    }, null, 8 /* PROPS */, ["validate-to"]),
                    _createCommentVNode(" @slot permette di aggiungere elementi dentro la modale di conferma invio checklist (dove si compila il testo della mail) "),
                    _renderSlot(_ctx.$slots, "matrice-invio-mail"),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistMatrice.testo_mail, (testoMail, testoMailKey) => {
                      return (_openBlock(), _createBlock(_component_base_textarea_floating_label, {
                        name: `testo-mail-${testoMailKey}`,
                        rows: "12",
                        class: "crm:mb-4",
                        validateTo: checklistMatrice.testo_mail[testoMailKey],
                        "onUpdate:validateTo": $event => ((checklistMatrice.testo_mail[testoMailKey]) = $event),
                        label: testoMailKey === 'de' ? 'Testo mail (versione tedesca)' : 'Testo mail'
                      }, null, 8 /* PROPS */, ["name", "validateTo", "onUpdate:validateTo", "label"]))
                    }), 256 /* UNKEYED_FRAGMENT */)),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_base_button, {
                        "onClick:cta": _cache[2] || (_cache[2] = $event => (_unref(modaleConfermaInvioChecklist).close()))
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("Annulla", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_base_button, {
                        "onClick:cta": _cache[3] || (_cache[3] = $event => (inviaCheckList())),
                        mode: "confirm"
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("Conferma", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (checklistMatrice.isShowConferma)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_base_alert_message, {
                      type: "success",
                      title: "Checklist correttamente inviata",
                      description: 'La checklist è stata correttamente inviata a ' + (checklistMatrice.soggetto.ragione_sociale ? checklistMatrice.soggetto.ragione_sociale : (checklistMatrice.soggetto.nome + ' ' + checklistMatrice.soggetto.cognome)) + ' all\'indirizzo email: '+checklistMatrice.soggetto.email
                    }, {
                      "alert-icon-badge": _withCtx(() => [
                        _createVNode(_component_base_icon, {
                          icon: _unref(alert_information_circle),
                          stroke: _unref($DesignSystem).design_colors.success,
                          sizing: {width: '30px', height: '30px'},
                          class: "crm:mr-10"
                        }, null, 8 /* PROPS */, ["icon", "stroke"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["description"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_base_button, {
                        "onClick:cta": chiudiModaliChecklist,
                        class: "crm:mt-4!"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("Chiudi", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["title", "id", "is-closable"]))
        : _createCommentVNode("v-if", true)
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}
}

}